<template>
    <div
        v-if="appParams && appParams.staticTranslations"
        class="container pt-4 pb-5"
        id="itb-privacy-policy"
    >
        <h1>{{ appParams.staticTranslations["cookies_policy.text_001"] }}</h1>
        <p style="opacity: 0.5">
            {{ appParams.staticTranslations["cookies_policy.text_002"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_003"] }}
            <a
                href="https://www.privacypolicies.com/cookies-policy-generator/"
                target="_blank"
                >{{
                    appParams.staticTranslations["cookies_policy.text_004"]
                }}</a
            >.
        </p>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_005"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_006"] }}
        </p>
        <h2>{{ appParams.staticTranslations["cookies_policy.text_007"] }}</h2>
        <h3>{{ appParams.staticTranslations["cookies_policy.text_008"] }}</h3>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_009"] }}
        </p>
        <h3>{{ appParams.staticTranslations["cookies_policy.text_010"] }}</h3>
        <p>{{ appParams.staticTranslations["cookies_policy.text_011"] }}</p>
        <ul>
            <li>
                <strong>{{
                    appParams.staticTranslations["cookies_policy.text_012"] +
                    " "
                }}</strong
                >{{ appParams.staticTranslations["cookies_policy.text_013"] }}
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["cookies_policy.text_014"]
                }}</strong
                >{{ appParams.staticTranslations["cookies_policy.text_015"] }}
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["cookies_policy.text_016"]
                }}</strong
                >{{ appParams.staticTranslations["cookies_policy.text_017"] }}
                <a
                    href="https://epdm-graphics.com/"
                    rel="nofollow noopener"
                    target="_blank"
                    >https://epdm-graphics.com/</a
                >
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["cookies_policy.text_018"]
                }}</strong
                >{{ appParams.staticTranslations["cookies_policy.text_019"] }}
            </li>
        </ul>
        <h2>{{ appParams.staticTranslations["cookies_policy.text_020"] }}</h2>
        <h3>{{ appParams.staticTranslations["cookies_policy.text_021"] }}</h3>
        <p>{{ appParams.staticTranslations["cookies_policy.text_022"] }}</p>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_023"] }}
        </p>
        <ul>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["cookies_policy.text_024"]
                    }}</strong>
                </p>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_025"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_026"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_027"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["cookies_policy.text_028"]
                    }}</strong>
                </p>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_029"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_026"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_030"]
                    }}
                </p>
            </li>
        </ul>
        <h3>{{ appParams.staticTranslations["cookies_policy.text_031"] }}</h3>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_032"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_033"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_034"] }}
        </p>
        <ul>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_035"]
                    }}
                    <a
                        href="https://support.google.com/accounts/answer/32050"
                        rel="external nofollow noopener"
                        target="_blank"
                        >https://support.google.com/accounts/answer/32050</a
                    >
                </p>
            </li>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_036"]
                    }}
                    <a
                        href="http://support.microsoft.com/kb/278835"
                        rel="external nofollow noopener"
                        target="_blank"
                        >http://support.microsoft.com/kb/278835</a
                    >
                </p>
            </li>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_037"]
                    }}
                    <a
                        href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored"
                        rel="external nofollow noopener"
                        target="_blank"
                        >https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored</a
                    >
                </p>
            </li>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["cookies_policy.text_038"]
                    }}
                    <a
                        href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                        rel="external nofollow noopener"
                        target="_blank"
                        >https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac</a
                    >
                </p>
            </li>
        </ul>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_039"] }}
        </p>
        <h3>{{ appParams.staticTranslations["cookies_policy.text_040"] }}</h3>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_041"] }}
            <a
                href="https://www.privacypolicies.com/blog/cookies/"
                rel="external nofollow noopener"
                target="_blank"
                >{{
                    appParams.staticTranslations["cookies_policy.text_042"]
                }}</a
            >.
        </p>
        <h3>Contact Us</h3>
        <p>
            {{ appParams.staticTranslations["cookies_policy.text_043"] }}
            <a href="mailto:graphics@4soft.cz">graphics@4soft.cz</a>
        </p>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {};
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
        }),
    },

    mounted() {
        axios
            .get("/getCookiesPolicyPage")
            .then((response) => {
                // this.heroCards = response.data.heroCards;
                this.pageParams = response.data.params;
                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        ...mapActions(["setPageParams", "setFormParams"]),
    },
};
</script>
